import React from 'react'
import { Trans } from '@lingui/react/macro'
import { useLingui } from '@lingui/react/macro'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const CheckIn = () => {
  const { t } = useLingui()

  return (
    <>
      <Card gap='$4'>
        <Paragraph size='$5'>
          <Trans>
            For in-person Events, organizers can track attendance at the door using
            the check-in feature. As attendees arrive at the venue, organizers mark
            them as checked in from the attendee list.
          </Trans>
        </Paragraph>
        <DocScreenshot
          src='docs/events/event-page.png'
          alt={t`Event page showing attendee list — organizers use this list to check in attendees at the door`}
          caption={t`Organizers check in attendees from the Event page attendee list`}
        />
      </Card>

      <Card gap='$4'>
        <DocSection id='check-in-methods' title={t`Check-In Methods`}>
          <YStack gap='$3'>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon name='checkmark' size='$5' color='$color' flexShrink={0} marginTop={2} />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>QR code check-in</Paragraph> —
                  Each attendee receives a unique QR code that organizers can scan at the
                  door for fast, contactless check-in. This works especially well for
                  larger Events where manual name lookups would slow down entry.
                </Trans>
              </Paragraph>
            </XStack>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon name='search' size='$5' color='$color' flexShrink={0} marginTop={2} />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>Manual check-in</Paragraph> —
                  Organizers can also search for attendees by name and mark them as checked
                  in manually. This is useful as a backup or for walk-in attendees who
                  RSVP at the door.
                </Trans>
              </Paragraph>
            </XStack>
            <XStack gap='$3' alignItems='flex-start'>
              <Icon name='people' size='$5' color='$color' flexShrink={0} marginTop={2} />
              <Paragraph size='$5'>
                <Trans>
                  <Paragraph size='$5' fontWeight='$7'>Organizer check-in view</Paragraph>{' '}
                  — The check-in interface shows a real-time count of checked-in attendees
                  versus total RSVPs, giving organizers an accurate picture of who has
                  actually arrived versus who committed to attending.
                </Trans>
              </Paragraph>
            </XStack>
          </YStack>
        </DocSection>
      </Card>

      <Card gap='$4'>
        <DocSection id='check-in-insights' title={t`Attendance Insights`}>
          <Paragraph size='$5'>
            <Trans>
              Check-in data helps you understand your community's attendance patterns
              over time. By comparing RSVPs to actual check-ins across multiple Events,
              you can better estimate turnout and plan venue capacity for future{' '}
              <Link href='/docs/events/overview'>Events</Link>.
            </Trans>
          </Paragraph>
        </DocSection>
      </Card>
    </>
  )
}

export default CheckIn
